module.exports = __webpack_public_path__ + "static/media/new-how-it-works.46a14350.png";